import { createContext, useContext, useLayoutEffect, useState, type ReactNode } from 'react';
import { SmartFillBridgeClient } from './client';

export {
  SmartFillBridgeClient,
  SmartFillBridgeDisconnectedError,
  SmartFillBridgeRequestError
} from './client';

const SmartFillBridgeContext = createContext<SmartFillBridgeClient | null>(null);

interface SmartFillBridgeProviderProps {
  children: ReactNode;
  client?: SmartFillBridgeClient | null;
}

export function SmartFillBridgeProvider({ children, client = null }: SmartFillBridgeProviderProps) {
  const [ownedClient, setOwnedClient] = useState<SmartFillBridgeClient | null>(null);

  useLayoutEffect(() => {
    if (client || window.parent === window) return;
    const nextClient = new SmartFillBridgeClient();
    setOwnedClient(nextClient);
    return () => {
      nextClient.disconnect();
    };
  }, [client]);

  return (
    <SmartFillBridgeContext.Provider value={client ?? ownedClient}>
      {children}
    </SmartFillBridgeContext.Provider>
  );
}

export function useSmartFillBridge(): SmartFillBridgeClient | null {
  return useContext(SmartFillBridgeContext);
}
